import ProfileVisibilityInfo from './ProfileVisibilityInfo';

export default ProfileVisibilityInfo;
